// Is this device the household's, or a sitter's? Asked once per key and
// remembered, so the sitter view survives going offline.

import { useEffect } from 'react';
import { ApiError, api } from './api.ts';
import { devicePrefs, isSession, setDevicePrefs } from './device.ts';
import { reconnect } from './index.ts';
import { useDevice } from './hooks.ts';

export function useRole(): { guest?: { name: string; expires: number }; expired: boolean } {
  const d = useDevice();
  useEffect(() => {
    if (!d.key) return;
    api<{ role: 'owner'; via?: 'key' | 'google'; email?: string; name?: string; personId?: string; renew?: string } | { role: 'guest'; name: string; expires: number }>('/api/whoami')
      .then((r) => {
        if (r.role === 'guest') return setDevicePrefs({ guest: { name: r.name, expires: r.expires } });
        setDevicePrefs({
          guest: undefined,
          ...(r.via === 'google' && r.email ? { account: { email: r.email, name: r.name } } : {}),
          // A Google sign-in knows who's holding the phone.
          ...(r.via === 'google' && r.personId && !devicePrefs().personId ? { personId: r.personId } : {}),
        });
        // Google sessions are topped up quietly once they're a month old.
        if (r.renew && isSession(devicePrefs().key)) {
          setDevicePrefs({ key: r.renew });
          void reconnect();
        }
      })
      .catch((err) => {
        // A revoked sitter link: keep the sitter view but mark it expired.
        if (err instanceof ApiError && err.status === 401 && d.key?.startsWith('sit-')) setDevicePrefs({ guest: { name: d.guest?.name ?? 'Sitter', expires: 0 } });
      });
  }, [d.key]);
  return { guest: d.guest, expired: !!d.guest && d.guest.expires < Date.now() };
}
